"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTERED_USER_EVENT = void 0;
// TODO: There is a separate event with the same name in @ori-events/integration-agro. Are both used? Can this be removed?

const REGISTERED_USER_EVENT = exports.REGISTERED_USER_EVENT = 'user-registered';